import Home from './component/home/home';
import './App.css';
import Navbar from './component/navbar/navbar';
import { Route, Routes } from 'react-router-dom';
import Footer from './component/footer/Footer';
import About from './component/about/About';
import Applications from './component/applications/Applications';
import ContactDetails from './component/contactDetails/ContactDetails';


function App() {
  return (
    <>
      <Navbar />
      <Routes>
      <Route path='/' element={<Home />}/>
      <Route path='/contact' element={<ContactDetails/>}/>
      <Route path='/about' element={<About/>}/>
      <Route path='/applications' element={<Applications/>}/>
      </Routes>
      <Footer />
    </>
  );
}

export default App;
